import React from 'react';
import { EntityMembersListCard } from '@backstage/plugin-org';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    // Grid items default to min-width:auto, which lets long emails overflow into neighbors.
    '& ul[class*="memberList"] > li > *': {
      minWidth: 0,
      maxWidth: '100%',
    },
    '& [class*="cardTextContainer"]': {
      minWidth: 0,
    },
    '& [class*="singlelineEllipsis"]': {
      display: 'block',
      width: '100%',
    },
  },
});

/** Members list with overflow fixes for narrow group overview layouts. */
export const GroupMembersListCard = () => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <EntityMembersListCard />
    </Box>
  );
};
